/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { breakpoints } from '@coursera/cds-core';

import CourseraPlusButton from 'bundles/composable-page-header/components/coursera-plus-button/CourseraPlusButton';

const styles = {
  linkWrapper: css`
    border-top: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    margin-top: var(--cds-spacing-100);
    padding: var(--cds-spacing-100) 0;
    list-style-type: none;

    ${breakpoints.up('md')} {
      a {
        &:hover,
        &:focus {
          /* Inherit the current dropdown item hover color */
          background-color: #f0f0f0 !important;
          outline: none !important;
        }
      }
    }
  `,
};

const CourseraPlusButtonListItem = () => {
  return (
    <li css={styles.linkWrapper}>
      <CourseraPlusButton />
    </li>
  );
};

export default CourseraPlusButtonListItem;
